import "./waiting.css"

export default function Won() {
    return (
        <>
            <div className="waiting">
                <div>
                    <h2 style={{ fontSize: 24 }}>Game Won...</h2>
                </div>
            </div>
        </>
    )
}